import 'angular:locale/data:fr-FR';
import './src/polyfills.ts';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "fr-FR";
